import axiosInstance from "@/axiosConfig";
import { getApiUrl } from "@/shared/utils/api";
import { DIRECT_DEBIT_ENDPOINTS } from "../configs/endpoints";
import type {
  BankAccountRequest,
  BankAccountRequestPayload,
  CodeChannel,
  DirectDebitSituation,
  PaymentRequest,
  PaymentRequestPayload,
} from "../types/directDebit.types";

/**
 * The CSE's Yeati subscription debit. yeati-api reads it from the CRM and writes the requests the
 * CRM carries out within seconds: a request is created `pending`, then read again until it is not.
 */
export class DirectDebitService {
  static async getSituation(): Promise<DirectDebitSituation> {
    const { data } = await axiosInstance.get<DirectDebitSituation>(getApiUrl(DIRECT_DEBIT_ENDPOINTS.SITUATION));
    return data;
  }

  static async sendConfirmationCode(channel: CodeChannel): Promise<{ channel: CodeChannel, sent_to: string }> {
    const { data } = await axiosInstance.post<{ channel: CodeChannel, sent_to: string }>(
      getApiUrl(DIRECT_DEBIT_ENDPOINTS.CONFIRMATION_CODE),
      { channel },
    );
    return data;
  }

  static async requestBankAccount(payload: BankAccountRequestPayload): Promise<BankAccountRequest> {
    const { data } = await axiosInstance.post<BankAccountRequest>(
      getApiUrl(DIRECT_DEBIT_ENDPOINTS.BANK_ACCOUNT_REQUESTS),
      payload,
    );
    return data;
  }

  static async getBankAccountRequest(id: number): Promise<BankAccountRequest> {
    const { data } = await axiosInstance.get<BankAccountRequest>(getApiUrl(DIRECT_DEBIT_ENDPOINTS.BANK_ACCOUNT_REQUEST(id)));
    return data;
  }

  static async requestPayment(payload: PaymentRequestPayload): Promise<PaymentRequest> {
    const { data } = await axiosInstance.post<PaymentRequest>(getApiUrl(DIRECT_DEBIT_ENDPOINTS.PAYMENT_REQUESTS), payload);
    return data;
  }

  static async getPaymentRequest(id: number): Promise<PaymentRequest> {
    const { data } = await axiosInstance.get<PaymentRequest>(getApiUrl(DIRECT_DEBIT_ENDPOINTS.PAYMENT_REQUEST(id)));
    return data;
  }
}
